import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { NoTranslate, A, BlankLink, DataTable } from '@contently/toolkit';
import { get } from '../../../utils/shared/api';
import Datetime from '../toolkit/Datetime';
import ContentRequestStatusIndicator from './ContentRequestStatusIndicator';

export default () => {
  const [data, setData] = useState([]);
  const columns = useMemo(
    () => [
      {
        Header: 'Title',
        accessor: 'title',
        noTranslate: true,
        filterOptions: {
          type: 'search',
          placeholder: 'Title...'
        },
        filter: DataTable.filterByContaining('title'),
        Cell: cell => (
          <A href={`/content_requests/${cell.row.original.id}`} title={cell.row.original.title}>
            <NoTranslate text={cell.row.original.title} />
          </A>
        )
      },
      {
        Header: 'Publication',
        id: 'publicationName',
        accessor: cr => cr.contentRequestForm.brandProfile.name,
        noTranslate: true,
        filter: DataTable.filterByExactly(row => row.contentRequestForm.brandProfile.name),
        filterOptions: {
          type: 'select',
          options: row => row.contentRequestForm.brandProfile.name
        }
      },
      {
        Header: 'Form',
        id: 'contentRequestFormName',
        accessor: row => row.contentRequestForm.name,
        Cell: cell => (
          <BlankLink
            href={cell.row.original.contentRequestForm.externalFormUrl}
            title="Content request form"
          >
            <NoTranslate text={cell.row.original.contentRequestForm.name} />
          </BlankLink>
        ),
        filterOptions: {
          type: 'select',
          options: row => row.contentRequestForm.name
        },
        filter: DataTable.filterByExactly(row => row.contentRequestForm.name),
        sortMethod: DataTable.sortBy(row => row.contentRequestForm.name)
      },
      {
        Header: 'Submitter',
        id: 'submitter',
        accessor: row => row.externalUser.submitter,
        Cell: cell => (
          <NoTranslate>{`${cell.row.original.externalUser.fullName} (${cell.row.original.externalUser.email})`}</NoTranslate>
        ),
        filterOptions: {
          type: 'search',
          placeholder: 'Name...'
        },
        filter: DataTable.filterByContaining(
          row => row.externalUser.fullName,
          row => row.externalUser.email
        )
      },
      {
        Header: 'Date of submission',
        accessor: 'createdAt',
        Cell: cell => (
          <Datetime timestamp={cell.row.original.formattedCreatedAt} formatType="date" />
        )
      },
      {
        Header: 'Status',
        id: 'status',
        accessor: 'status',
        Cell: cell => (
          <ContentRequestStatusIndicator
            value={{ status: cell.row.original.status, statusHumanize: cell.row.original.status }}
          />
        ),
        filterOptions: {
          type: 'select',
          options: [
            ['Accepted', 'accepted'],
            ['Declined', 'declined'],
            ['Awaiting review', 'awaiting_review']
          ]
        },
        filter: DataTable.filterByExactly('status'),
        sortMethod: DataTable.sortBy('status')
      }
    ],
    []
  );

  const fetchData = async () => {
    const contentRequests = await get('/api/v1/content_requests');
    setData(contentRequests);
  };
  useEffect(() => {
    fetchData();
  }, []);

  if (!data.length) return <Fragment />;

  return (
    <div className="content-wrapper-inner">
      <DataTable.Table data={data} columns={columns} recordNoun="content request" />
    </div>
  );
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_requests/content_requests.jsx